var _defs, _rect, _rect2, _path, _path2, _line, _line2, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Square",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.94 141.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-1,.cls-2,.cls-4{stroke:#f3a623;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-1{stroke-width:4px;}.cls-2,.cls-4{stroke-width:5px;}.cls-3{fill:#f1a623;stroke:#184848;stroke-width:9px;opacity:0.5;}.cls-4,.cls-5{fill:#f3a623;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Envelope Inverted Yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 137.94,
    height: 137.94
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 25.26,
    y: 37.15,
    width: 91.5,
    height: 68.25,
    rx: 7.4,
    ry: 7.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.23,39.67L80.33,77.05a13.46,13.46,0,0,1-19,0L28.51,38.78",
    transform: "translate(0.11 0.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.78,36.71",
    transform: "translate(0.11 0.11)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 25,
    y1: 103.03,
    x2: 57.14,
    y2: 74.66
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 116.42,
    y1: 102.37,
    x2: 84.28,
    y2: 75
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "111.47 40.8 93.16 62.25 82.81 74.38 92.49 81.99 102.76 90.73 116.42 102.37 116.76 81.11 116.76 61.11 116.76 44.54 111.47 40.8"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "30.56 37.8 48.86 61.25 59.21 73.38 49.53 80.99 39.27 89.73 25.6 101.37 25.26 80.11 25.26 60.11 25.26 43.54 30.56 37.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailActive);
export default __webpack_public_path__ + "static/media/email-active.6c2dbb703c024406c2291708181284cf.svg";
export { ForwardRef as ReactComponent };